var n={NUMBER_0:0,NUMBER_1:1,NUMBER_2:2,NUMBER_3:3};function r(n){return t(n)}function t(n,r){return n}function u(n){return n}export{n as TargetType,r as TargetTypeFromJSON,t as TargetTypeFromJSONTyped,u as TargetTypeToJSON};
